import { useEffect } from "react";
import { Box } from "@mui/material";
import { CafeCardScroll, CafeTable } from ".";
import { CenterLoading } from "../util/CenterLoading";
import { useCafeViewStore } from "../../store/cafeViewStore";
import { useLoadingStore } from "../../store/loadingStore";
import { useWindowSize } from "../../hooks/useWindowSize";
import { post } from "../../lib/api";
import { banner } from "../images";
import { PostInfo } from "./types";

const styles = {
  root: (isMobile: boolean) => [
    !isMobile && { p: 3, bgcolor: "lightGrey", flex: 1 },
  ],
  wrapper: (isMobile: boolean) => ({
    px: "min(10%, 3rem)",
    py: "2rem",
    p: isMobile ? "0.3rem 1rem" : "",
    bgcolor: "white",
    borderRadius: 8,
  }),
};

export const CafeView = () => {
  const { width } = useWindowSize();

  // mobile: ~768px, tablet: ~1024px
  const isMobile = width <= 1024;

  const setRows = useCafeViewStore(({ setRows }) => setRows);
  const setLoading = useLoadingStore(({ setLoading }) => setLoading);

  useEffect(() => {
    const fetchCafePosts = async () => {
      const { data } = await post("/v1/beautyMania/articles");
      setRows(data?.posts?.map(({ data }: { data: PostInfo }) => data) || []);
      setLoading(false);
    };

    fetchCafePosts();
  }, [setRows, setLoading]);

  return (
    <Box sx={styles.root(isMobile)}>
      {isMobile && <img src={banner} alt="banner" width="100%" />}
      <Box sx={styles.wrapper(isMobile)}>
        {isMobile ? <CafeCardScroll /> : <CafeTable />}
        <CenterLoading />
      </Box>
    </Box>
  );
};
